import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Amount } from "@design-system/Amount/Amount";
import { InvoiceLineItem } from "@common/types/invoice";
import { getInvoiceLineItemDisplayAmount } from "@common/helpers/lineItems";

export const AmountCell = memo(
    ({ row }: CellContext<ViewTableFeatures, InvoiceLineItem, number>) => {
        const lineItem = row.original;

        return (
            <ViewTableCell>
                <Amount
                    amount={getInvoiceLineItemDisplayAmount(lineItem)}
                    showNegative
                />
            </ViewTableCell>
        );
    },
);
